import React from 'react';

import { NewsFormEdit } from 'App/components/News/components/NewsForm';

import {
  Action,
  Actions,
  ListItem,
  List,
  NoResults,
  makeStyles,
  Section,
  MarkdownRender,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { useIsAllowed } from '@gogame/permissions';

import { MarkdownContainer } from './components';
import NewsTitle from './components/NewsTitle';
import { NEWS_MANAGEMENT_PERMISSION } from './constants';
import { useLoadNews, useRemoveNews } from './data';

const useStyles = makeStyles((theme) => {
  return {
    list: {
      paddingTop: 0,
      height: '100%',
      overflow: 'auto',
      '&::-webkit-scrollbar-track': {
        borderLeft: `1px solid ${theme.palette.divider}`,
      },
    },
    itemSection: {
      borderTop: 'none',
      width: '100%',
      padding: '16px',
    },
  };
});

const NewsList = ({ type = 0 }) => {
  const classes = useStyles();
  const isAllowed = useIsAllowed();
  const [childComponent, openChildComponent] = useChildComponent();

  const { data } = useLoadNews(type);

  const [removeNews] = useRemoveNews();

  const handleEdit = (data) => {
    openChildComponent(NewsFormEdit, {
      data,
    });
  };

  const handleDelete = async (id) => {
    await removeNews({ id });
  };

  return (
    <>
      {data ? (
        <List className={classes.list}>
          {data?.map((item) => {
            return (
              <ListItem key={item?.id} disablePadding={true}>
                <Section
                  className={classes.itemSection}
                  title={<NewsTitle type={item?.type} date={item?.date} />}
                  isCollapsable
                  initialOpen={false}
                  action={
                    isAllowed(NEWS_MANAGEMENT_PERMISSION) ? (
                      <Actions limit={0}>
                        <Action
                          label={'Edit'}
                          onClick={() => handleEdit(item)}
                        />
                        <Action
                          label={'Delete'}
                          onClick={() => handleDelete(item?.id)}
                        />
                      </Actions>
                    ) : null
                  }
                >
                  <MarkdownContainer as={'div'}>
                    <MarkdownRender value={item.text} />
                  </MarkdownContainer>
                </Section>
              </ListItem>
            );
          })}
        </List>
      ) : (
        <NoResults inited={!!data} />
      )}
      {childComponent}
    </>
  );
};

export default NewsList;
